import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarBundleItem() {
    const route = useRoute();

    const bundle = reactive({
        id: StringUtils.toNumber(route.params.bundleId),
        status: null,
        isExists: false
    });

    const loadBundle = useCrudActions().executeAction({
        request: avatarService.bundle.get,
        onSuccess: ({ data }) => {
            bundle.isExists = true;
            bundle.status = data.status;
        }
    });

    const { list, total, fetchList } = useBaseListView({
        request: avatarService.bundle.listItem,
        paramsBuilder: () => ({ bundleId: bundle.id }),
        hooks: {
            loadInitialData: () => loadBundle(bundle.id),
            canFetch: () => bundle.isExists,
            transformResponse: list => list.map(item => ({ ...item, canUnlink: bundle.status === 0 }))
        }
    });

    const actions = {
        unlink: useCrudActions().confirmAndExecute({
            confirmMessage: 'Are you sure you want to unlink this item?',
            request: avatarService.bundle.unlink,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, bundle, actions };
}
